import Vue from 'vue';

// A la carte mode - See: https://vuetifyjs.com/en/features/treeshaking/#vuetify-loader
// Note: Treeshaking will only work with Webpack 4 in production mode. This is automatic when using Vue CLI.
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// export the config for use in Storybook
export const vuetifyConfig = {
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#448AFF',
        secondary: '#414D6B',
        accent: '#4AA6C3',
        error: '#EF5050',
        info: '#2196F3',
        success: '#19AA55',
        warning: '#FFA552',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
};

export default new Vuetify(vuetifyConfig);
